import AppBarAdmin from "../../components/AppBarAdmin"
import AppBarUser from "../../components/AppBarUser"
import CustomDivider from "../../components/CustomDivider"
import Formulario from "../../components/Formulario"

export default function NovaSolicitacao() {
    return(
        <>
            <AppBarUser title="Nova Solicitação" />
            <CustomDivider />
            <Formulario />
        </>
    )
}